export class Blog {
    displayId?: string;
    readTime: string = '0';
    wordCount: number = 0;
    id: string = '';
    time: number = 0;
    version: string = '';
    createdBy: string = '';
    postSummary: string = '';
    postTitle: string = '';
    img : string = "";
    tags : string[] = [];
    blocks: any;
    blogMeta: BlogMeta = {
        metaTitle: '',
        metaDescription: {
            name: 'description',
            content: ''
        }
    };
    blogScheduledDate: string | null = null;
    blogScheduleTime: string | null = null;
    keyWords: MetaDefinition = {
        name: 'keywords',
        content: ''
    };
    author: MetaDefinition = {
        name: 'author',
        content: ''
    };
    blogStatus: BlogStatus = BlogStatus.SAVE;
    businessId: string | null = '';
    blogType: BlogType = BlogType.BUSINESS;
    updatedTimeStamp: string = '';
    createdTimeStamp: string = '';
    subIndustryId: string = '';
    subIndustryName: string = '';
    publishedDate: string | null = null;
    articleSlug: string = '';
    categoryId: string | null = null;
    categoryName: string | null = null;
    totalVisits: number = 0;

    constructor(blogData?: Blog) {
        if (blogData) {
            this.displayId = blogData.displayId;
            this.readTime = blogData.readTime || '0';
            this.author = blogData.author || {
                name: 'author',
                content: ''
            };
            this.blocks = blogData.blocks || [];
            this.blogScheduleTime = blogData.blogScheduleTime;
            this.blogScheduledDate = blogData.blogScheduledDate;
            this.blogStatus = blogData.blogStatus || BlogStatus.SAVE;
            this.blogType = blogData.blogType || BlogType.BUSINESS;
            this.businessId = blogData.businessId;
            this.createdBy = blogData.createdBy;
            this.createdTimeStamp = blogData.createdTimeStamp;
            this.id = blogData.id;
            this.keyWords = blogData.keyWords || {
                name: 'keywords',
                content: ''
            };
            this.postSummary = blogData.postSummary || '';
            this.postTitle = blogData.postTitle || '';
            this.time = blogData.time;
            this.updatedTimeStamp = blogData.updatedTimeStamp;
            this.version = blogData.version;
            this.wordCount = blogData.wordCount;
            this.blogMeta = blogData.blogMeta || {
                metaTitle: '',
                metaDescription: {
                    name: 'description',
                    content: ''
                }
            };
            this.subIndustryId = blogData.subIndustryId || '';
            this.subIndustryName = blogData.subIndustryName || '';
            this.articleSlug = blogData.articleSlug || '';
            this.categoryId = blogData.categoryId || null;
            this.categoryName = blogData.categoryName || null;
            this.totalVisits = blogData.totalVisits || 0;
        }
    }

    addTag(tag: string): boolean {
        if (!tag) return false;

        const previousTags = this.keyWords.content.split(',');
        
        if(previousTags.length === 1 && !previousTags[0]) {
            previousTags.pop();
        };

        if(previousTags.includes(tag)) return false;

        previousTags.push(tag);
        this.keyWords.content = previousTags.join(',');

        return true;
    }

    removeTag(removeTagName: string): boolean {
        const previousTags = this.keyWords.content.split(',');
        const removingTagIndex = previousTags.findIndex((tag: string) => tag === removeTagName);

        if (removingTagIndex > -1) {
            previousTags.splice(removingTagIndex, 1);
            this.keyWords.content = previousTags.join(',');

            return true;
        }

        return false;
    }

    addAuthor(author: string): boolean {
        if (!author) return false;

        const previousAuthors = this.author.content.split(',');

        if(previousAuthors.length === 1 && !previousAuthors[0]) {
            previousAuthors.pop();
        };

        if(previousAuthors.includes(author)) return false;

        previousAuthors.push(author);
        this.author.content = previousAuthors.join(',');

        return true;
    }

    removeAuthor(removeAuthorName: string): boolean {
        const previousAuthors = this.author.content.split(',');
        const removingAuthorIndex = previousAuthors.findIndex((author: string) => author === removeAuthorName);

        if (removingAuthorIndex > -1) {
            previousAuthors.splice(removingAuthorIndex, 1);
            this.author.content = previousAuthors.join(',');

            return true;
        }

        return false;
    }
};

export interface MetaDefinition {
    name: string;
    content: string;
};

export interface BlogMeta {
    metaTitle: string;
    metaDescription: MetaDefinition
};

export enum BlogStatus {
    "SAVE"="SAVE",
    "PUBLISH"="PUBLISH",
    "SCHEDULED"="SCHEDULED",
    "ALL"="ALL"
}

export enum BlogType {
    "MASTER"="MASTER",
    "BUSINESS"="BUSINESS"
}

export interface Tag {
    blogCount: number;
    businessId: string;
    createdById: string;
    createdByName: string;
    description: string;
    id: string;
    tagName: string;
    createdTimeStamp: string;
}

export interface Author {
    authorId: string;
    authorName: string;
    blogCount: number;
    businessId: string;
    createdById: string;
    createdByName: string;
    createdTimeStamp: string;
    email: string;
    id: string;
    imageUrl: string;
}

export interface Category {
    id: string;
    businessId: string;
    categoryName: string;
    description: string;
    blogsCreatedCount: number;
    createdById: string;
    createdByName: string;
    createdTimeStamp: string;
}

export const Blog_Cachekeys = {
    "BLOG_SETTINGS": "BLOG_SETTINGS"
}

export interface BlogFilterRequest {
    businessId: string;
    status: BlogStatus | null;
    page: number;
    size: number,
    authors: string[];
    tags: string[];
    categoryId: string | null;
    publishDate: string | null;
    searchText: string;
}

export interface SelectedOption {
    fieldValue: string,
    fieldText: string,
    fieldName: string
}

export interface EditorHeaderBlock {
  type: 'header';
  data: {
    text: string;
    level: number;
  };
}
export interface EditorParagraphBlock {
  type: 'paragraph';
  data: {
    text: string;
  };
}
export interface EditorImageBlock {
  type: 'image';
  data: {
    file: {
      url: string;
    };
    withBorder: boolean;
    stretched: boolean;
    withBackground: boolean;
  };
}

export interface EditorListBlock {
  type: 'list';
  data: {
    style: 'ordered' | 'unordered';
    items: string[];
  };
}

export interface WebSocketMessage {
  conversation_id: string;
  type: string;
  timestamp: string;
  data?: any;
  message?: string;
}

export interface SectionAddedMessage extends WebSocketMessage {
  type: 'section_added';
  data: {
    new_section: {
      title: string;
      content: string;
    };
    updated_blog?: string | any;
  };
}

export interface ProcessCompleteMessage extends WebSocketMessage {
  type: 'process_complete' | 'Process Complete.';
  data: {
    blog_post: any;
  };
}

export interface AgentStatusMessage extends WebSocketMessage {
  type: 'agent_status';
  data: {
    status: string;
  };
}

export interface ThinkingStreamMessage extends WebSocketMessage {
  type: 'thinking_stream';
  data: {
    thought?: string;
    message?: string;
  };
}

export interface ResearchStreamMessage extends WebSocketMessage {
  type: 'research_stream';
  data: {
    query: string;
    sources?: any[];
  };
}

export interface AddSectionCompleteMessage extends WebSocketMessage {
  type: 'add_section_complete';
  data: {
    status: 'success' | 'error';
    message: string;
    updated_blog: string | any;
  };
}

export interface EditSectionCompleteMessage extends WebSocketMessage {
  type: 'edit_section_complete';
  data: {
    status: 'success' | 'error';
    message: string;
    original_text?: string;
    edited_text?: string;
    updated_blog?: string | any;
  };
}

export interface BlogUpdatedMessage extends WebSocketMessage {
  type: 'blog_updated';
  data: {
    blog_post: any;
  };
}

export interface TextExpansionInfoMessage extends WebSocketMessage {
  type: 'text_expansion_info';
  data: {
    original_selection: string;
    expanded_text: string;
    expansion_type: 'paragraph' | 'sentence' | 'partial' | 'error';
    paragraph_boundaries?: any;
    context_before?: string;
    context_after?: string;
  };
}

export interface EnhancedSectionUpdatedMessage extends WebSocketMessage {
  type: 'section_updated';
  data: {
    original_text: string;
    expanded_text?: string;
    edited_text: string;
    improvement_notes?: string;
    quality_score?: number;
    regeneration_type?: string;
    expansion_type?: 'paragraph' | 'sentence' | 'partial' | 'error';
    paragraph_boundaries?: any;
    context_before?: string;
    context_after?: string;
  };
}

export interface BlogChatEvent {
  type: "connected" | "handshake_ack" |
        "tool_start" | "tool_end" | "agent_action" | "complete" | "agent_response" | "error" |
        "blog_metadata" | "blog_generated" | "process_complete";
  conversation_id?: string;
  user_id?: string;
  business_id?: string;
  timestamp: string;
  content?: string;
  tool_name?: string;
  text?: string;
  step?: number;
  message?: string;
  data?: {
    blog_metadata?: AiBlogMetadata;
    action?: string;
    blog_post?: any;
    success?: boolean;
  };
}

export interface AiBlogMetadata {
  id: string;
  title: string;
  blog_summary?: string;
  topic: string;
  objective?: string;
  blog_type?: string;
  content_structure_type?: string;
  seo_keywords: string[];
  read_time_minutes: number;
  total_word_count?: number;
  sections_count: number;
  paragraphs_count: number;
  professional_elements: string[];
  engagement_elements: string[];
  created_at: string;
  last_edited_at?: string;
  edit_count: number;
  research_used: boolean;
  brand_voice_applied?: any;
}

export interface EmailChatEvent {
  type: "connected" | "handshake_ack" |
        "tool_start" | "tool_end" | "agent_action" | "complete" | "agent_response" | "error" |
        "email_metadata" | "email_generated" | "email_optimized" | "process_complete";
  conversation_id?: string;
  user_id?: string;
  business_id?: string;
  timestamp: string;
  content?: string;
  tool_name?: string;
  text?: string;
  step?: number;
  message?: string;
  data?: {
    email_metadata?: EmailMetadata;
    action?: string;
    email?: any;
    success?: boolean;
  };
}

export interface EmailMetadata {
  id: string;
  subject_line: string;
  subject?: string;
  body?: string;
  plain_text_content?: string;
  html_content?: string;
  content?: string; // Generic content field
  estimated_read_time?: number;
  word_count?: number;
  sections?: EmailSection[];
  personalization_score?: number;
  email_type?: string;
  target_audience?: string;
  brand_voice?: {
    voice_tone?: string;
    writing_style?: string;
    formality_level?: string;
  };
  action_type?: string;
  created_at: string;
  last_edited_at?: string;
  edit_count?: number;
}

export interface EmailSection {
  title?: string;
  content: string;
  order?: number;
}

export interface EmailConversationThread {
  userMessage: string;
  aiResponses: any[];
  emailContent: EmailMetadata | null;
  timestamp: Date;
  isComplete: boolean;
  agentActivity?: any;
  conversationId?: string;
  completedAt?: Date;
  requiresClarification?: boolean;
  liked?: boolean;
  disliked?: boolean;
}